import StripeErrors from "lib/StripeErrors";

export default class StripeRecurringFlow {
  constructor(stripeManager) {
    this.stripeManager = stripeManager;
  }

  /**
   * 1. Submits the donor's contact details and the payment intent to our
   *   backend, which which creates a new customer and subscription in Stripe
   *   (`submitForm()`) and returns an object containing some details of the
   *   payment intent and its status
   * 2. Calls out to Stripe for further confirmation if the payment intent's
   *   status requires it (`confirmCardPayment()`)
   * @param paymentMethod a payment method provided by Stripe, e.g. as returned
   *   from `StripeManager.createPaymentMethod()`
   * @param donationDetails to be passed through to the TC-Donate backend when
   * submitting the donation. See `DonationFormManager.donationDetails`.
   * @return {Promise<unknown>}
   */
  async executePayment({ donationDetails, paymentMethod }) {
    const stripePaymentMethodId = paymentMethod.id;
    const paymentTokens = { stripePaymentMethodId };
    const result = await this.stripeManager.submitForm({
      donationDetails,
      paymentTokens,
    });

    // Call out to the user for confirmation using confirmCardPayment if
    // returned status is "requires_action". If status is "requires_source",
    // then there is an error
    // see https://stripe.com/docs/payments/accept-a-payment-synchronously#web-create-payment-intent
    const { stripe_payment_intent_status: paymentIntentStatus } = result;
    if (paymentIntentStatus) {
      if (paymentIntentStatus.match(/requires_source$/)) {
        throw StripeErrors();
      }
      if (paymentIntentStatus.match(/requires_.*action/)) {
        const paymentResult = await this.stripeManager.confirmCardPayment({
          clientSecret: result.stripe_payment_intent_client_secret,
        });

        if (paymentResult.error) {
          const error = { cardNumber: paymentResult.error.message };
          throw error;
        }
      }
    }
  }
}
